<template>
    <modal :show.sync=show modalClasses="medium-sized-modal modal-hide-footer">
        <h3 slot="header" class="mb-0 font-weight-500">Clawback</h3>
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form ref="hubForm" role="form" @submit.prevent="submit()" class="my-0">
                <b-row>
                    <b-col cols="12" class="text-center mb-3">
                        <p>Confirm Clawback Commission<br>for this member ?</p>
                    </b-col>
                    <b-col cols="12" class="text-center">
                        <b-button type="submit" class="w-100" variant="primary" :disabled="invalid">Confirm</b-button>
                    </b-col>
                </b-row>
                <!-- <b-row>
                    <b-col md="6" cols="12" class="mx-auto text-center mt-4 pt-2">
                    </b-col>
                </b-row> -->
            </b-form>
        </ValidationObserver>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import {axios, services, getHeader } from '@/assets/js/httpImports.js'
import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'

export default {
    props:{
        clawback: Boolean
    },
    mixins: [notifyFunctionMixin],
    components: {
        ValidationObserver,
        ValidationProvider,
        Modal,
    },
    computed: {
        show: {
            get() {
                return this.clawback;
            },
            set(newVal) {
                this.$emit('update:clawback', newVal);
            },
        },
    },
    data(){
        return {
            form: {
                name: '',
                hub_manager: '',
                target: '',
                type: '',
                setting: {
                    max_hub_teams_number: '',
                    max_hub_team_members_number: '',
                },
            },
            selectTypeOptions: [],
            selectHubManagerOptions: [],
        }
    },
    created() {
        //
    },
    methods: {
        submit() {
            //
        },
        viewDetails(){
            this.show = true
        }
    }
}
</script>